import {ContractType} from '../warranties/contract-type.model';

export class AdminActionPeriod {

  id: number;
  createdBy: string;
  dateCreated: string;

  selectedRegions: string[] = [];
  selectedDealers: string[] = [];
  selectedModels: string[] = [];
  selectedVins: string[] = [];
  selectedContractType: ContractType = null;
  selectedContractCode: string = null;
  dateFrom: string;
  dateTo: string;
  selectedBrand: string = null;
  dateMade: string;
  warrantyCreationDateFrom: string;
  warrantyCreationDateTo: string;
}
